<!-- <div class="row">
    <span class="closex" (click)="actionClose()"> X </span>
</div> -->
<div style="display: flex;flex-direction: column;">
    <div style="background: #fff; padding: 0px; padding-left: 10px;
    overflow: hidden; display: flex;flex-direction: column;">

        <h3 style="font-size: 23px !important;
            font-weight: 900 !important;margin-top: 10px;">{{data.title}} - Edit</h3>
        <div style="height: 80%;">
            <quill-editor class="editor" style="height:70vh;" [(ngModel)]="data.data.salesPolicy" *ngIf="data.params==='terms'">
            </quill-editor>
            <quill-editor [(ngModel)]="data.data.faq"  style="height:70vh;" *ngIf="data.params==='faq'"></quill-editor>
        </div>


    </div>

    <div class="action_block" >
        <button mat-raised-button color="accent" class="cancel" (click)="actionCancel()">Cancel</button>
        <button mat-raised-button color="primary" class="save" (click)="actionSave()"> Save </button>
    </div>
</div>